import Keycloak from 'keycloak-js';

const keycloakConfig = {
  url: process.env.REACT_APP_KEYCLOAK_URL || 'http://localhost:8080', // URL del servidor Keycloak
  realm: 'braincode', // Nombre del reino
  clientId: 'docuchat-ai-client', // ID del cliente
};

const keycloak = new Keycloak(keycloakConfig);
//console.log(keycloak);

export default keycloak;